// tslint:disable

import * as React from 'react';
//import {InputField} from '../../components/fields/input.field';
import {FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';
import {IriField} from "../../components/fields/iri.field";
import {IriPresenter} from "../../components/structurals/presenters/iri-presenter";
import {get} from 'lodash';
import {TextAreaField} from "../../components/fields/textarea.field";
import {SelectField} from "../../components/fields/select.field";

export class DefaultEventAttendee extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {


        form.fields.event.registerField();
        form.fields.event.setValue(this.props.CONFIG.event);

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="attendee" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new attendee' : 'Edit attendee'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="Attendee details" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-xs-12">

                            <IriField
                                defaultAll={false}
                                field={form.fields.personCompany}
                                itemRender={ (item: any) =>
                                    <div>
                                        <IriPresenter iri={get(item, 'person.@id')} render={(person: any) =>
                                            get(person, 'firstName') + ' ' + get(person, 'surName')
                                        }/> ({item.email})
                                    </div>
                                }
                            />
                            <IriField
                                defaultAll={true}
                                field={form.fields.guestType}
                                itemRender={(item: any) => item.title}
                            />
                            <TextAreaField
                                field={form.fields.specialNeeds}
                            />

                            <SelectField
                                field={form.fields.status}
                                options={[
                                    {value: 1, label: 'Pending'},
                                    {value: 2, label: 'Denied'},
                                    {value: 3, label: 'Accepted'},
                                    {value: 4, label: 'Attended'},
                                    {value: 5, label: 'DNA'},
                                ]}
                            />

                            <button className="btn btn-success pull-left" onClick={() => this.saveForm(form)}>Save
                            </button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.event-attendee.tsx